import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { locales } from '../../../translations/locales';
import BtnStatus from '../configuration/status/BtnStatus';
import checkDatePlanning from '../../../controllers/checkDatePlanning';
import { _setText } from '../../../controllers/dom';
import Radio from '../radio/Radio';
import Ticket from './Ticket';

const Home = (props) => {
    const { data, ModuleRP, locale, theme, assignment } = props;

    const [building, setBuilding] = useState(data.assignments.find((e) => e.id === assignment) || null);
    const [showRadio, setShowRadio] = useState(false);
    const [vehiclePlayer, setVehiclePlayer] = useState(null);

    const handleOpenWindow = () => {
        const newWindow = window.open('', '_blank', 'width=990,height=301');
        const container = newWindow.document.createElement('div');
        newWindow.document.body.appendChild(container);
        Array.from(document.styleSheets).forEach((styleSheet) => {
            if (styleSheet.href) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.href = styleSheet.href;
                newWindow.document.head.appendChild(link);
            } else if (styleSheet.cssRules) {
                const style = document.createElement('style');
                Array.from(styleSheet.cssRules).forEach((rule) => {
                    style.appendChild(document.createTextNode(rule.cssText));
                });
                newWindow.document.head.appendChild(style);
            }
        });
        ReactDOM.createRoot(container).render(<Radio ModuleRP={ModuleRP} vehicle={vehiclePlayer} />);
        newWindow.onbeforeunload = () => {
            ModuleRP.Radio.sounds.reception.pause();
            setShowRadio(false);
        };
    };
    const playerAdded = [];

    useEffect(() => {
        setBuilding(data.assignments.find((e) => e.id === assignment));
        _setText('screenName', `<h4 class="m-1">${locales[locale].config.assignments}</h4>`);
        if (building) {
            building.vehicles.map((vehicle) => {
                if (
                    vehicle.manning.find((manning) => manning?.player?.id === ModuleRP.userId) &&
                    vehicle.status !== ModuleRP.listStatus.find((s) => s.system === 'SELECTED').code
                ) {
                    setShowRadio(true);
                    return setVehiclePlayer(vehicle);
                }
            });
        }
    }, [data, assignment, building, showRadio]);

    return (
        <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
            {
                showRadio && <div className={`text-center bg-${theme === 'DARK' ? 'dark' : 'light'} m-5`}>
                    <button
                        type='button'
                        className='btn btn-primary mr-5'
                        onClick={handleOpenWindow}
                    >
                        {locales[locale].radio.openRadio}
                    </button>
                    <Ticket
                        ModuleRP={ModuleRP}
                        locale={locale}
                        missionId={vehiclePlayer.missionId}
                        vehicleId={vehiclePlayer.id}
                        buildingId={building.id}
                    />
                </div>
            }
            <div className="card container p-0 gameInformations mt-5">
                <h5 className="card-header bg-primary">
                    {locales[locale].assignments.vehiclesSynoptic}
                </h5>
                <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    {
                        building?.vehicles.length > 0 && building.vehicles?.map((vehicle) => {
                            return (
                                <BtnStatus
                                    key={vehicle.id}
                                    listStatus={ModuleRP.listStatus}
                                    code={vehicle.status}
                                    text={vehicle.name}
                                />
                            );
                        })
                    }
                </div>
            </div>
            <div className="card container p-0 gameInformations mt-5">
                <h5 className="card-header bg-primary">
                    {locales[locale].assignments.staffSynoptic}
                </h5>
                <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    {ModuleRP.planningStatus.map((planningStatus) => (
                        <div key={planningStatus.id} className="row">
                            <h5
                                key={planningStatus.id}
                                style={{ color: planningStatus.color }}
                            >
                                {locales[locale].planning[planningStatus.id]}
                            </h5>
                            <div className="col-12">
                                {
                                    building?.staff?.length > 0 &&
                                    ModuleRP.planningStatus.map((planningStatusBis) => {
                                        if (planningStatusBis.id === planningStatus.id) {
                                            const staffInPlanning = building.staff.map((staff) => {
                                                const player = data.listPlayers.find((player) => player.id === staff);
                                                if (!player) return null;
                                                const isPlayerInPlanning = player.schedules.some((schedule) => {
                                                    return (
                                                        schedule.status === planningStatusBis.id &&
                                                        schedule.assignment === assignment &&
                                                        schedule.day === new Date().getDate() &&
                                                        schedule.month === new Date().getMonth() + 1 &&
                                                        checkDatePlanning(schedule.startTime, '>') &&
                                                        checkDatePlanning(schedule.endTime, '<')
                                                    );
                                                });
                                                if (isPlayerInPlanning ||
                                                    (!isPlayerInPlanning && planningStatusBis.etat === 4) &&
                                                    !playerAdded.includes(player.id)
                                                ) {
                                                    playerAdded.push(player.id);
                                                    return (
                                                        <BtnStatus
                                                            key={`${staff}-${planningStatusBis.id}`}
                                                            listStatus={ModuleRP.listStatus}
                                                            code={player.status}
                                                            text={player.name}
                                                        />
                                                    );
                                                }
                                                return null;
                                            });
                                            return staffInPlanning.filter(Boolean);
                                        }
                                    })
                                }
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Home;
